import React, {useEffect, useState} from 'react';
import {getMatchList} from "../../../services/matches";
import {useAuth} from "../../../contexts/authContext";
import Tabs from 'react-simply-tabs';
import {withRouter} from "react-router-dom";
import ScaleLoader from "react-spinners/ScaleLoader";
import {getUnconcludedPaidRegistrations, getUnconcludedUnpaidRegistrations} from "../../../services/registrations";
import moment from "moment";
import {Col, Row} from "react-bootstrap";
import {useSwipeableHook} from "../../../utils";
import {useTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header';
import GameCard from '../../../components/GameCard';
import NoRegistrationsAlert from "../../../components/NoRegistrationsAlert";

// CSS Files
import './styles.css';

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
`;

const GamesList = (props) => {
   const [games, setGames] = useState(null);
   const [unconcludedRegistrations, setUnconcludedRegistrations] = useState([]);
   const [loading, setLoading] = useState(true);
   const auth = useAuth();
   const {handlers, activeTabIndex, setActiveTabIndex} = useSwipeableHook(games?.gameTypes.length);
   const { t } = useTranslation();

   useEffect(() => {
      (async () => {
         let unconcludedPaidRegistrations = await getUnconcludedPaidRegistrations();
         let unconcludedUnpaidRegistrations = await getUnconcludedUnpaidRegistrations();
         let games = await getMatchList(
            auth.user.active_enrollment?.id,
            auth.user.active_enrollment?.league_edition_id,
            auth.user.active_enrollment?.league_id,
            auth.user.active_enrollment?.league_category_id,
            auth.user.active_enrollment?.league_division_id
         );

         setUnconcludedRegistrations(unconcludedPaidRegistrations.concat(unconcludedUnpaidRegistrations));
         setGames(games);
         setLoading(false);
      })()
   }, [auth.user.active_enrollment]);

   if (!games)
      return null;

   let generateTabs = () => {
      return games.gameTypes.map((tab, key) => {
         return <div key={key} className="inner-tab-container">
               {tab.tab_name === "pendentes" ? (
                  <>
                     {tab.schedule_types.map((type, typeKey) => (
                        <React.Fragment key={typeKey}>
                           <span className="inner-tab-subtitle">{type.type}</span>
                           {type.games.length === 0 ? (
                              <div className={"d-flex justify-content-center align-items-center mt-5 mb-5 no-matches-text"}>
                                 {t("common.all_done")}
                              </div>
                           ) : (
                              <div className="games-tab-content">
                                 {type.games.map((game, gameKey) => (
                                    <GameCard key={gameKey} gameInfo={game}/>
                                 ))}
                              </div>
                           )}
                        </React.Fragment>
                     ))}
                  </>
               ) : (
                  <>
                     <span className="inner-tab-subtitle">{tab.subtitle ? tab.subtitle : ''}</span>
                     {tab.games.length === 0 && tab.tab_name === "agendados" && (
                        <div className={"d-flex justify-content-center align-items-center mt-5 no-matches-text"}>
                           {t("my_matches_page.no_matches_to_play").toUpperCase()}
                        </div>
                     )}
                     {tab.games.length === 0 && tab.tab_name === "realizados" && (
                        <div className={"d-flex justify-content-center align-items-center mt-5 no-matches-text"}>
                           {t("my_matches_page.no_finished_matches").toUpperCase()}
                        </div>
                     )}
                     {tab.games.length !== 0 && (
                        <div className="games-tab-content">
                           {tab.games.map((game, gameKey) => (
                              <React.Fragment key={gameKey}>
                                 {game.state === "suspended" ? (
                                    <GameCard key={gameKey} gameInfo={game} streakText={t("my_matches_page.suspended_match")}/>
                                 ) : (
                                    <GameCard key={gameKey} gameInfo={game}/>
                                 )}
                              </React.Fragment>
                           ))}
                        </div>
                     )}
                  </>
               )}
            </div>
      });
   };

   return <div className={"GamesList"}>
      <Header
         headerBarTitle={t("my_matches_page.header")}
         class={"mb-0"}
         showHeaderExtras>
      </Header>

      {!auth.user.active_enrollment && unconcludedRegistrations.length > 0 &&
         <Row>
            <Col xs={{span: 10, offset: 1}}>
               <div className="alert alert-info mt-4" role="alert">
                  {t("my_matches_page.edition_not_started_notice", {accepted_entries_notice: moment(unconcludedRegistrations[0].accepted_entries_notice).format("DD/MM/YYYY"), interpolation: { escapeValue: false }})}
               </div>
            </Col>
         </Row>
      }

      {!auth.user.active_enrollment && unconcludedRegistrations.length === 0 &&
         <NoRegistrationsAlert
            text={t("common.no_registrations")}
         />
      }

      <ScaleLoader
         css={override}
         sizeUnit={"px"}
         size={30}
         color={'#afff55'}
         loading={loading}
      />

      {auth.user.active_enrollment && !loading &&
         <div className={"flex-grow-1"} {...handlers}>
            <Tabs
               activeTabIndex={activeTabIndex}
               onRequestChange={setActiveTabIndex}
               wrapperProps={{
                  className: "tabs-container",
                  handlers: handlers
               }}
               controlsWrapperProps={{
                  className: "tab-controls-container"
               }}
               activeControlProps={{
                  className: "tab-control-active"
               }}
               controls={[
                  <button key="pending" type="button" className="btn-tab-control">{t("my_matches_page.pending")}</button>,
                  <button key="scheduled" type="button" className="btn-tab-control">{t("my_matches_page.scheduled")}</button>,
                  <button key="played" type="button" className="btn-tab-control">{t("my_matches_page.played")}</button>
               ]}
            >
               {generateTabs()}
            </Tabs>

            <div className="full-games-container">
               {generateTabs()}
            </div>
         </div>
      }

   </div>
};

export default withRouter(GamesList);
